<template>
    <div class="give-gift-view">
        <div class="give-top-bg" @click.stop>
            <div style="font-size: 18px;font-weight: bold;color: #ffffff;margin-bottom: 10px;">
                送路费
            </div>
            <div class="give-top-line">
                <div style="width: 80px;text-align: right;">账号：</div>
                <div>{{giveGiftResult.userName}}</div>
            </div>
            <div class="give-top-line">
                <div style="width: 80px;text-align: right;">区服：</div>
                <div>{{giveGiftResult.serverName}}</div>
            </div>
            <div class="give-top-line">
                <div style="width: 80px;text-align: right;">角色名：</div>
                <div>{{giveGiftResult.roleName}}</div>
            </div>
            <div class="give-top-line">
                <div style="width: 80px;text-align: right;">VIP等级：</div>
                <div>{{giveGiftResult.vip}}</div>
            </div>
            <div class="give-top-line">
                <div style="width: 80px;text-align: right;">创建时间：</div>
                <div>{{giveGiftResult.addTime}}</div>
            </div>
            <div class="give-top-line">
                <div style="width: 80px;text-align: right;">赠送状态：</div>
                <div>{{giveGiftResult.sendStatus}}</div>
            </div>

            <div class="give-main-bg"  @click.stop>
                <div style="">
                    <van-field v-model="giveGiftRoleName" style="width: 140px;" placeholder="请输入角色名称"/>
                </div>
                <div @click="submitGiveGift" style=" width: 50px;margin-left: 8px;cursor: pointer;background-color: #ea2f2f;border-radius: 4px;height: 30px;line-height: 30px;">
                    赠送
                </div>
            </div>

        </div>
        <div @click="close" style="width: 25px;height: 25px;border-radius: 25px;background-color: rgba(0,0,0,0.37);margin-top: 10px;display: flex;align-items: center;justify-content: center;">
            <van-icon name="cross" size="18" color="#ffffff" style=""/>
        </div>

    </div>
</template>

<script>
import {Toast} from "vant";
import {request} from "@/api/request";

export default {
    name: 'GiveGift.vue',
    data() {
        return {
            giveGiftResult : {userName: '无', roleName: '无', serverName: '无', addTime: '无', vip: '无', sendStatus: '无'},
            giveGiftRoleName: '',
            gameId: '',
        };
    },
    mounted() {
        this.gameId = localStorage.getItem('gameId');
    },
    methods: {
        close() {
            this.$parent.giveGiftPageShow = false;
        },
        submitGiveGift() {
            if (!this.giveGiftRoleName) {
                Toast('请输入要赠送的角色名');
                return;
            }
            let options = {
                url: `/lingmou/sendWelfare?code=ds&roleName=${this.giveGiftRoleName}&gameId=${this.gameId}`,
                method: 'get'
            };
            request(options).then(res => {
                if(res.data.success){
                    Toast('赠送成功');
                    this.giveGiftRoleName = '';
                    this.giveGiftResult.userName = res.data.data.userName;
                    this.giveGiftResult.roleName = res.data.data.roleName;
                    this.giveGiftResult.serverName = res.data.data.serverName;
                    this.giveGiftResult.addTime = res.data.data.addTime;
                    this.giveGiftResult.vip = res.data.data.vip;
                    this.giveGiftResult.sendStatus = '赠送成功 '+ res.data.data.money +'绑币';
                }else {
                    this.$toast(res.data.error.message);

                }
            })
        },
    }
};
</script>

<style scoped>
.give-gift-view {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 100px;
}
.give-top-bg {
    width: 240px;
    color: #FFFFFF;
    font-size: 12px;
    padding: 15px 0;
    background-color: rgba(70, 70, 70, 0.68);
    border-radius: 8px;
}
.give-main-bg {
    width: 100%;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    margin-top: 40px;
}
.give-top-line {
    display: flex;
    align-items: center;
}
.van-cell {
    padding: 3px 10px;
    border-radius: 4px;
    font-size: 12px;
}
</style>